import React from 'react'
import PropTypes from 'prop-types'

const ICONS = {
  'check-circle': (
    <>
      <circle cx='12' cy='12' r='10' />
      <polyline points='8 12 11 15 16 9' />
    </>
  ),
  'alert-circle': (
    <>
      <circle cx='12' cy='12' r='10' />
      <line x1='12' y1='8' x2='12' y2='12' />
      <line x1='12' y1='16' x2='12.01' y2='16' />
    </>
  ),
  'info-circle': (
    <>
      <circle cx='12' cy='12' r='10' />
      <line x1='12' y1='16' x2='12' y2='12' />
      <line x1='12' y1='8' x2='12.01' y2='8' />
    </>
  ),
  'alert-triangle': (
    <>
      <path d='M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' />
      <line x1='12' y1='9' x2='12' y2='13' />
      <line x1='12' y1='17' x2='12.01' y2='17' />
    </>
  ),
  close: (
    <>
      <line x1='18' y1='6' x2='6' y2='18' />
      <line x1='6' y1='6' x2='18' y2='18' />
    </>
  ),
  mail: (
    <>
      <path d='M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z' />
      <polyline points='22 6 12 13 2 6' />
    </>
  ),
  refresh: (
    <>
      <polyline points='23 4 23 10 17 10' />
      <polyline points='1 20 1 14 7 14' />
      <path d='M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15' />
    </>
  ),
}

/**
 * Decorative stroke icon sized to the surrounding font and coloured by
 * `currentColor`. Library-neutral, so it renders the same whether or not the
 * legacy stylesheet is active.
 */
function InlineIcon({ name, className = '' }) {
  return (
    <svg
      className={`inline-icon ${className}`.trim()}
      data-icon={name}
      viewBox='0 0 24 24'
      width='1em'
      height='1em'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
      focusable='false'
    >
      {ICONS[name]}
    </svg>
  )
}

InlineIcon.propTypes = {
  name: PropTypes.oneOf(Object.keys(ICONS)).isRequired,
  className: PropTypes.string,
}

export default InlineIcon
